// commons.js
// Métodos utilitarios comunes para los componentes dentro de 'apps'

/**
 * Formatea una fecha a 'DD/MM/YYYY'
 * @param {Date|string} date
 * @returns {string}
 */
export function formatDate(date) {
    const d = new Date(date);
    if (isNaN(d)) return '';
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
}

/**
 * Capitaliza la primera letra de un string
 * @param {string} str
 * @returns {string}
 */
export function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Valida si un valor es un email válido
 * @param {string} email
 * @returns {boolean}
 */
export function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/**
 * Devuelve una copia profunda de un objeto
 * @param {object} obj
 * @returns {object}
 */
export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export const goToBugURL = () => {
  sessionStorage.setItem('bugReportReturnUrl', window.location.pathname + window.location.search);
  window.location.href = '/app/bug-report';
};